import { render, staticRenderFns } from "./FlaggingOverview.vue?vue&type=template&id=0f89c715&scoped=true"
import script from "./FlaggingOverview.vue?vue&type=script&lang=js"
export * from "./FlaggingOverview.vue?vue&type=script&lang=js"
import style0 from "./FlaggingOverview.vue?vue&type=style&index=0&id=0f89c715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89c715",
  null
  
)

export default component.exports